import Vue from 'vue'
import VueRouter from 'vue-router'
import * as RouterPage from '@/constants/route-page'
import liff from '@line/liff'

import store from '@/store'
import { getAuth, getMasterData, getFee, getCartAbandonmentSetting } from './func'
import { syncCart, initEnv, trackingPermission } from '@/utils'
import { getDevice, DEVICE } from '@/utils/helper.js'
import routes from '@/constants/router'
import { ENV_KEY } from '@/constants/env'
import { AMAZON } from '@/constants/amazon'
import { LINE_LOGIN_FROM_LOGIN_PAGE } from '@/constants'
Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_PREFIX,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})

router.beforeEach(async (to, from, next) => {
  if (!store.state.auth.initial) {
    try {
      await initEnv()

      await Promise.allSettled([getMasterData(), getFee(), getCartAbandonmentSetting()])

      if (store.getters['env/GET_KEY'](ENV_KEY.GTM_ID)) {
        await import('@/plugins/vue2-gtm')
      }

      if (store.getters['env/GET_KEY'](ENV_KEY.LIFF_ID)) {
        await import('@/plugins/liff').then(({ liffInit }) => liffInit)
      }
    } catch (error) {
      await trackingPermission()
      store.commit('auth/SET_INIT')
      next(RouterPage.EC_LINE001)
      return
    }

    try {
      await getAuth()

      await syncCart()
    } catch (error) {
      await store.dispatch('auth/removeAuth')
    }
    store.commit('auth/SET_INIT')
  }

  // Check exist cart
  if (['EC_LINE029_001', 'EC_LINE029_002'].includes(to.name) && !store.state.cart.carts.length) {
    next(store.getters['auth/isLogin'] ? RouterPage.EC_LINE001 : RouterPage.EC_LINE031)
    return
  }

  // Check has data when checkout
  if (['EC_LINE004', 'EC_LINE005'].includes(to.name)) {
    if (localStorage.getItem(AMAZON.CART_LINE029)) {
      const form = JSON.parse(localStorage.getItem(AMAZON.CART_LINE029))
      store.commit('register/SET_CUSTOMER', form)
      const shippingFee = Number(localStorage.getItem(AMAZON.SHIPPING_FEE))
      store.commit('cart/SET_SHIPPING_FEE', shippingFee)
    }

    if (!store.state.register.customer) {
      next(RouterPage.EC_LINE031)
      return
    }
  }

  const EC_LINE039 = 'EC_LINE039'
  const LINE_036 = 'EC_LINE036'

  if (!to.meta?.auth) {
    if (to.name === EC_LINE039) {
      if (!store.getters['env/GET_KEY'](ENV_KEY.LIFF_ID)) {
        next(RouterPage.EC_LINE001)
        return
      } else if (!liff.isLoggedIn()) {
        liff.login({
          redirectUri: `${store.getters['env/GET_KEY'](ENV_KEY.BASE_URL)}${process.env.VUE_APP_PREFIX}${to.path}`,
        })
        return
      } else {
        next()
      }
    } else if (to.name === LINE_036) {
      if (store.getters['env/GET_KEY'](ENV_KEY.LIFF_ID) && !liff.isLoggedIn() && getDevice() === DEVICE.SP) {
        liff.login({
          redirectUri: `${store.getters['env/GET_KEY'](ENV_KEY.BASE_URL)}${process.env.VUE_APP_PREFIX}${to.path}`,
        })
        return
      } else {
        next()
      }
    } else {
      next()
    }
  } else {
    if (!store.state.auth.user) {
      await getAuth()

      store.commit('auth/SET_INIT')

      if (!store.state.auth.user) {
        store.getters['env/GET_KEY'](ENV_KEY.LIFF_ID) && to.query[LINE_LOGIN_FROM_LOGIN_PAGE]
          ? next({
              path: RouterPage.EC_LINE039,
              query: to.query,
            })
          : autoLineLoginToNext(RouterPage.EC_LINE031, to, next)
      } else {
        next()
      }
    } else {
      next()
    }
  }
})

export default router

export const autoLineLoginToNext = (path, to, next) => {
  if (store.getters['env/GET_KEY'](ENV_KEY.LIFF_ID) && !liff.isLoggedIn() && getDevice() === DEVICE.SP) {
    liff.login({
      redirectUri: `${store.getters['env/GET_KEY'](ENV_KEY.BASE_URL)}${process.env.VUE_APP_PREFIX}${to.path}`,
    })
  }
  next({
    path: path,
  })
}
